import { render, staticRenderFns } from "./HistorialVentas.vue?vue&type=template&id=6fdc5527&scoped=true"
import script from "./HistorialVentas.vue?vue&type=script&lang=js"
export * from "./HistorialVentas.vue?vue&type=script&lang=js"
import style0 from "./HistorialVentas.vue?vue&type=style&index=0&id=6fdc5527&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdc5527",
  null
  
)

export default component.exports